import { LeverageFinancialsValues, LeverageFinancialsResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// We model leverage as price / (price - financingLevel)
export function calculateLeverageFinancials(values: LeverageFinancialsValues, t?: ToolsTranslations['leverageFinancials']): LeverageFinancialsResult {
  const { productPrice, financingLevel } = values;

  if (productPrice <= 0) {
    return { leverage: null, isValid: false, message: t?.invalid.productPrice ?? 'Produktpris måste vara större än 0' };
  }
  if (financingLevel <= 0) {
    return { leverage: null, isValid: false, message: t?.invalid.financingLevel ?? 'Finansieringsnivå måste vara större än 0' };
  }
  if (financingLevel >= productPrice) {
    return { leverage: null, isValid: false, message: t?.invalid.financingTooHigh ?? 'Finansieringsnivån måste vara mindre än priset' };
  }

  const equity = productPrice - financingLevel;
  const leverage = Math.round((productPrice / equity) * 100) / 100;

  if (!isFinite(leverage)) {
    return { leverage: null, isValid: false, message: t?.invalid.generic ?? 'Ogiltiga värden' };
  }

  return { leverage, isValid: true };
}


